// const config = {
//   API_BASE_URL: "https://test-image-viewer.latentforce.ai",
// };

// export default config;

// const config = {
//   API_BASE_URL: "http://127.0.0.1:8000",
// };

// export default config;


// const config = {
//   API_BASE_URL: "https://54.208.226.254",
// };

// export default config;

// const config = {
//   API_BASE_URL: "http://54.208.226.254",
// };

// export default config;


// const config = {
//   API_BASE_URL: "https://s3viewer.sblcorp.ai", 
// };

// export default config;




const config = {
  API_BASE_URL: "https://s3viewer-2.sblcorp.ai", 
};

export default config;

// https://s3viewer-2.sblcorp.ai/